import { render, staticRenderFns } from "./UserLayout.vue?vue&type=template&id=3a5d3dec&scoped=true"
import script from "./UserLayout.vue?vue&type=script&lang=js"
export * from "./UserLayout.vue?vue&type=script&lang=js"
import style0 from "./UserLayout.vue?vue&type=style&index=0&id=3a5d3dec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5d3dec",
  null
  
)

export default component.exports